module.exports = __webpack_public_path__ + "static/icon-54e54cab2fa07aac48bd5d272edb791c.png";